import React from 'react';
import { useParams } from 'react-router';
import { useQuery, gql } from '@apollo/client';
import { Card, Descriptions } from 'antd';
import DateDisplay from '../../../layout/DateDisplay';

const GET_INFO = gql`
  query getInfoForExtension($ids: [ID!], $status: Status) {
    projects(ids: $ids, status: $status) {
      nodes {
        id
        title
        profile {
          originalCompletionDate
          deadlineOfUsingUpFunding
          lastApprovedCompletionDate
        }
      }
    }
  }
`;

const ProfileInfo = () => {
  const { projectId } = useParams();
  const { data, loading } = useQuery(GET_INFO, {
    variables: { ids: [projectId], status: 'ALL' },
  });

  const profile = loading ? {} : data.projects.nodes[0].profile;

  return (
    <Card loading={loading}>
      {!loading && (
        <Descriptions>
          <Descriptions.Item label="Original Completion Date" span={3}>
            <DateDisplay date={profile.originalCompletionDate} />
          </Descriptions.Item>
          <Descriptions.Item label="Last Approved Completion" span={3}>
            <DateDisplay date={profile.lastApprovedCompletionDate} />
          </Descriptions.Item>
          <Descriptions.Item label="Deadline of Using Up Funding" span={3}>
            <DateDisplay date={profile.deadlineOfUsingUpFunding} />
          </Descriptions.Item>
        </Descriptions>
      )}
    </Card>
  );
};

export default ProfileInfo;
